export const MATERIAL_DEPENDENCIES = [
    {
        Category: "Field Shingles",
        RequiresCategories: [
            "Hip & Ridge",
            "Starter",
            "Nails (15 SQ/box)",
            "Nails (750 LF/box)",
            "Nails (12 SQ/box)",
            "Field Dry In",
            "Sealant / Adhesive",
            "Spray Paint",
        ],
        Mappings: [
            {
                Product: "Tamko Heritage",
                RequiredProducts: [
                    { Category: "Hip & Ridge", Product: "Tamko H&R" },
                    { Category: "Starter", Product: "Tamko Starter" },
                    { Category: "Nails (15 SQ/box)", Product: "1 and quarter inch" },
                    { Category: "Nails (750 LF/box)", Product: "1 and half inch" },
                    { Category: "Nails (12 SQ/box)", Product: "Plastic Cap Nails" },
                    { Category: "Field Dry In", Product: "Synthetic" },
                    { Category: "Sealant / Adhesive", Product: "Tamko Sealant" },
                    { Category: "Spray Paint", Product: "Tamko Roofing Spray Paint" },
                ],
            },
            {
                Product: "OC Oakridge",
                RequiredProducts: [
                    { Category: "Hip & Ridge", Product: "OC H&R" },
                    { Category: "Starter", Product: "OC Starter" },
                    { Category: "Nails (15 SQ/box)", Product: "1 and quarter inch" },
                    { Category: "Nails (750 LF/box)", Product: "1 and half inch" },
                    { Category: "Nails (12 SQ/box)", Product: "Plastic Cap Nails" },
                    { Category: "Field Dry In", Product: "Synthetic" },
                ],
            },
            {
                Product: "GAF Armorshield II",
                RequiredProducts: [
                    { Category: "Hip & Ridge", Product: "Seal a Ridge IR" },
                    { Category: "Starter", Product: "GAF Starter" },
                    { Category: "Nails (15 SQ/box)", Product: "1 and quarter inch" },
                    { Category: "Nails (750 LF/box)", Product: "1 and half inch" },
                    { Category: "Nails (12 SQ/box)", Product: "Plastic Cap Nails" },
                    { Category: "Field Dry In", Product: "Synthetic" },
                ],
            },
            {
                Product: "OC Duration",
                RequiredProducts: [
                    { Category: "Hip & Ridge", Product: "OC H&R" },
                    { Category: "Starter", Product: "OC Starter" },
                    { Category: "Nails (15 SQ/box)", Product: "1 and quarter inch" },
                    { Category: "Nails (750 LF/box)", Product: "1 and half inch" },
                    { Category: "Nails (12 SQ/box)", Product: "Plastic Cap Nails" },
                    { Category: "Field Dry In", Product: "Synthetic" },
                ],
            },
            {
                Product: "OC Flex",
                RequiredProducts: [
                    { Category: "Hip & Ridge", Product: "OC H&R" },
                    { Category: "Starter", Product: "OC Starter" },
                    { Category: "Nails (15 SQ/box)", Product: "1 and quarter inch" },
                    { Category: "Nails (750 LF/box)", Product: "1 and half inch" },
                    { Category: "Nails (12 SQ/box)", Product: "Plastic Cap Nails" },
                    { Category: "Field Dry In", Product: "Synthetic" },
                ],
            },
            {
                Product: "Tamko IR",
                RequiredProducts: [
                    { Category: "Hip & Ridge", Product: "Tamko H&R" },
                    { Category: "Starter", Product: "Tamko Starter" },
                    { Category: "Nails (15 SQ/box)", Product: "1 and quarter inch" },
                    { Category: "Nails (750 LF/box)", Product: "1 and half inch" },
                    { Category: "Nails (12 SQ/box)", Product: "Plastic Cap Nails" },
                    { Category: "Field Dry In", Product: "Synthetic" },
                ],
            },
            {
                Product: "Cert. Flex",
                RequiredProducts: [
                    { Category: "Hip & Ridge", Product: "Shadowridge IR" },
                    { Category: "Starter", Product: "Cert. Starter" },
                    { Category: "Nails (15 SQ/box)", Product: "1 and quarter inch" },
                    { Category: "Nails (750 LF/box)", Product: "1 and half inch" },
                    { Category: "Nails (12 SQ/box)", Product: "Plastic Cap Nails" },
                ],
            },
            {
                Product: "Cert. Northgate",
                RequiredProducts: [
                    { Category: "Hip & Ridge", Product: "Shadowridge IR" },
                    { Category: "Starter", Product: "Cert. Starter" },
                    { Category: "Nails (15 SQ/box)", Product: "1 and quarter inch" },
                    { Category: "Nails (750 LF/box)", Product: "1 and half inch" },
                    { Category: "Nails (12 SQ/box)", Product: "Plastic Cap Nails" },
                ],
            },
            {
                Product: "GAF Grand Sequoia",
                RequiredProducts: [
                    { Category: "Hip & Ridge", Product: "Seal a Ridge" },
                    { Category: "Starter", Product: "GAF Starter" },
                    { Category: "Double Starter", Product: "GAF Seq/Canyon Start" },
                    { Category: "Nails (15 SQ/box)", Product: "1 and half inch" },
                    { Category: "Nails (750 LF/box)", Product: "1 and three quarter inch" },
                    { Category: "Nails (12 SQ/box)", Product: "Plastic Cap Nails" },
                    { Category: "Field Dry In", Product: "Synthetic" },
                ],
            },
            {
                Product: "GAF Grand Sequoia IR",
                RequiredProducts: [
                    { Category: "Hip & Ridge", Product: "Seal a Ridge IR" },
                    { Category: "Starter", Product: "GAF Starter" },
                    { Category: "Double Starter", Product: "GAF Seq/Canyon Start" },
                    { Category: "Nails (15 SQ/box)", Product: "1 and half inch" },
                    { Category: "Nails (750 LF/box)", Product: "1 and three quarter inch" },
                    { Category: "Nails (12 SQ/box)", Product: "Plastic Cap Nails" },
                    { Category: "Field Dry In", Product: "Synthetic" },
                ],
            },
            {
                Product: "GAF Grand Canyon",
                RequiredProducts: [
                    { Category: "Hip & Ridge", Product: "Timbertex" },
                    { Category: "Starter", Product: "GAF Starter" },
                    { Category: "Double Starter", Product: "GAF Seq/Canyon Start" },
                    { Category: "Nails (15 SQ/box)", Product: "1 and half inch" },
                    { Category: "Nails (750 LF/box)", Product: "1 and three quarter inch" },
                    { Category: "Nails (12 SQ/box)", Product: "Plastic Cap Nails" },
                    { Category: "Field Dry In", Product: "Synthetic" },
                ],
            },
            {
                Product: "Cert. Prez Shake",
                RequiredProducts: [
                    { Category: "Hip & Ridge", Product: "Cedar Creast" },
                    { Category: "Starter", Product: "Cert. Starter" },
                    { Category: "Double Starter", Product: "Cert. Pres Starter" },
                    { Category: "Nails (15 SQ/box)", Product: "1 and half inch" },
                    { Category: "Nails (750 LF/box)", Product: "1 and three quarter inch" },
                    { Category: "Nails (12 SQ/box)", Product: "Plastic Cap Nails" },
                ],
            },
            {
                Product: "Cert. Prez IR",
                RequiredProducts: [
                    { Category: "Hip & Ridge", Product: "Cedar Crest IR" },
                    { Category: "Starter", Product: "Cert. Starter" },
                    { Category: "Double Starter", Product: "Cert. Pres IR Starter" },
                    { Category: "Nails (15 SQ/box)", Product: "1 and half inch" },
                    { Category: "Nails (750 LF/box)", Product: "1 and three quarter inch" },
                    { Category: "Nails (12 SQ/box)", Product: "Plastic Cap Nails" },
                ],
            },
            {
                Product: "Cert. TL",
                RequiredProducts: [
                    { Category: "Hip & Ridge", Product: "Mountain Ridge" },
                    { Category: "Starter", Product: "Cert. Starter" },
                    { Category: "Double Starter", Product: "Cert. Starter" },
                    { Category: "Nails (15 SQ/box)", Product: "1 and half inch" },
                    { Category: "Nails (750 LF/box)", Product: "1 and three quarter inch" },
                    { Category: "Nails (12 SQ/box)", Product: "Plastic Cap Nails" },
                ],
            },
        ],
    },
    {
        Category: "Ridge Vent",
        RequiresCategories: ["Hip & Ridge"],
        Mappings: [
            {
                Product: "Master Flow Ridge Vent",
                RequiredProducts: [],
            },
        ],
    },
    {
        Category: "Ice & Water Shield",
        RequiresCategories: ["Drip Edge / Eave", "Drip Edge / Rake"],
        Mappings: [
            {
                Product: "3 ft",
                RequiredProducts: [
                    { Category: "Drip Edge / Eave", Product: "Aluminum Drip Edge" },
                    { Category: "Drip Edge / Rake", Product: "Steel Drip Edge" },
                ],
            },
            {
                Product: "4.5 ft",
                RequiredProducts: [
                    { Category: "Drip Edge / Eave", Product: "Aluminum Drip Edge" },
                    { Category: "Drip Edge / Rake", Product: "Steel Drip Edge" },
                ],
            },
            {
                Product: "6 ft",
                RequiredProducts: [
                    { Category: "Drip Edge / Eave", Product: "Aluminum Drip Edge" },
                    { Category: "Drip Edge / Rake", Product: "Steel Drip Edge" },
                ],
            },
        ],
    },
    {
        Category: "Valley Liner",
        RequiresCategories: ["Ice & Water Shield"],
        Mappings: [
            {
                Product: "Tarco",
                RequiredProducts: [{ Category: "Ice & Water Shield", Product: "3 ft" }],
            },
        ],
    },
];
